import React from 'react';
import { Calendar } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface JourneyMilestone {
  title: string;
  date: string;
  description: string;
  completed: boolean;
}

export const JourneySoFarSection: React.FC<{ milestones: JourneyMilestone[] }> = ({ milestones }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="bg-white rounded-xl border border-gray-100 p-6 flex flex-col shadow-sm min-h-[100px] max-h-[450px]">
      <h2 className="text-xl font-semibold text-gray-900 mb-6">{t('dashboard.journeyRoadmap.title', 'Health Journey Roadmap')}</h2>
      
      <div className="relative overflow-y-auto pr-4">
        {/* Vertical Timeline Line */}
        <div className="absolute left-4 top-2 bottom-2 w-0.5 bg-gray-200"></div>
        
        {/* Timeline Items */}
        <div className="space-y-8">
          {milestones.map((milestone, index) => (
            <div key={index} className="flex items-start gap-6 relative">
              {/* Circle Marker */}
              <div className="relative z-10 w-8 h-8 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center">
                <div className={`w-4 h-4 rounded-full ${milestone.completed ? 'bg-green-500' : 'bg-gray-300'}`}></div>
              </div>
              
              {/* Content */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-medium text-gray-900">{milestone.title}</h3>
                </div>
                
                <div className="flex items-center text-gray-500 text-sm mb-1">
                  <Calendar className="w-4 h-4 mr-1" />
                   {new Date(milestone.date).toLocaleDateString(i18n.language, { month: 'short', day: 'numeric' })}
                </div>
                
                <p className="text-gray-600">{milestone.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default JourneySoFarSection;